const publicUrl = process.env.PUBLIC_URL || '';
const fondoUrl = `${publicUrl}/fondo.png`;

export function createFondoBackgroundStyle({
  attachment = 'fixed',
  overlay = 'rgba(255,255,255,0.34)',
} = {}) {
  return {
    backgroundImage: `linear-gradient(${overlay}, ${overlay}), url('${fondoUrl}')`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: attachment,
  };
}